import { useMemo } from 'react';
import { Shield, FileText, MessageSquare, Gamepad2 } from 'lucide-react';
import { FormHeader } from '@/components/forms';
import { TabsWithPersistence } from '@/components/shared/TabsWithPersistence';
import { useScrollRestoration } from '@/hooks/use-scroll-restoration';
import { ContentModerationTab } from './components/content-tab';
import { ChatModerationTab } from './components/chat-tab';
import { GameModerationTab } from './components/game-tab';

export function ModerationPage() {
  useScrollRestoration();
  const tabs = useMemo(() => [
    {
      value: 'content',
      label: 'Контент',
      icon: <FileText className="h-4 w-4" />,
      content: <ContentModerationTab />,
    },
    {
      value: 'chats',
      label: 'Чаты',
      icon: <MessageSquare className="h-4 w-4" />,
      content: <ChatModerationTab />,
    },
    {
      value: 'games',
      label: 'Игры',
      icon: <Gamepad2 className="h-4 w-4" />,
      content: <GameModerationTab />,
    },
  ], []);

  return (
    <div className="space-y-6">
      <FormHeader
        title="Модерация"
        description="Управление контентом, чатами и играми"
        sticky
        icon={<Shield className="h-5 w-5" />}
      />

      <TabsWithPersistence
        tabs={tabs}
        defaultTab="content"
        persistKey="moderation"
        tabsListClassName="inline-flex"
      />
    </div>
  );
}
